export enum MenuPlacement {
    Center = 'center',
    Left = 'left',
    Right = 'right'
}
